module.exports = __webpack_public_path__ + "assets/img/DS-master (8).e2b91c65.jpg";